import React, { FC }    from "react";
import { Button, Icon } from "semantic-ui-react";

type Props = {
  onClick: () => void;
  label: string;
}

const SaveButton: FC<Props> = ({onClick, label}) => (
  <>
    <Button
      icon
      positive
      labelPosition="left"
      onClick={() => onClick()}
    >
      <Icon name="save"/>
      { label }
    </Button>
  </>
);

export default SaveButton;